export default __webpack_public_path__ + "static/media/example.f7889be7.xlsx";